import React from "react";
import "../../../../index.css";
import "./homeScorecardCard.css";
import Button from "../../../../components/button/button";
import { useState, useEffect } from "react";
import Accordion from "../../../../components/accordion/accordion";
import PopUpModal from "../../../../popUpForms/formModals/popUpFormModal";

const HomeScorecardCard = ({
  id,
  title,
  titleColor,
  image,
  caption,
  content,
  popUpComponent,
  hoveredTab,
  onTabHover,
  onTabLeave,
}) => {
  const [imageSpecialStyle, setImageSpecialStyle] = useState(false);
  const [popUpFormVisible, setPopUpFormVisible] = useState(false);
  const [activeForm, setActiveForm] = useState("");

  useEffect(() => {
    if (title.startsWith("Scorecard")) {
      setImageSpecialStyle(true);
    }
  }, []);

  const handleShowPopUpForm = () => {
    setActiveForm(id);
    setPopUpFormVisible(true);
  };

  return (
    <div
      id={`${id}`}
      className="scorecard home-card-box"
      style={{
        border: hoveredTab === id ? `1px solid ${titleColor}` : "",
      }}
      onMouseEnter={() => onTabHover(id)}
      onMouseLeave={() => onTabLeave()}
    >
      <div className="card-content">
        <h3 className="card-title" style={{ color: titleColor }}>
          {title}
        </h3>
        {image && (
          <div
            className={imageSpecialStyle ? "card-image special" : "card-image"}
          >
            <img src={`${image}`} alt="card-image" />
          </div>
        )}
        {caption && <figcaption>{caption}</figcaption>}
        {content &&
          content.map((item) => {
            switch (item.type) {
              case "paragraph":
                return item.text.includes("<a") ? (
                  <p
                    style={{ color: item.color }}
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  />
                ) : (
                  <p
                    style={{ color: item.color }}
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  ></p>
                );

              case "header-H4":
                return item.text.includes("<br") ? (
                  <h4
                    className="header"
                    style={{ color: item.color }}
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  />
                ) : (
                  <h4 className="header" style={{ color: item.color }}>
                    {item.text}
                  </h4>
                );

              case "list":
                return (
                  <ul>
                    <p>{item.header}</p>
                    {item.list.map((bullet) => (
                      <li>{bullet}</li>
                    ))}
                  </ul>
                );
              case "accordion":
                return <Accordion data={item.data} />;

              case "header-H5":
                return (
                  <h5 style={{ color: item.color, fontStyle: "italic" }}>
                    {item.text}
                  </h5>
                );

              case "button":
                return item.badge ? (
                  <div className="card-btn-row">
                    <Button
                      onClick={handleShowPopUpForm}
                      className="card-btn"
                      text={item.text}
                      color={item.color}
                      link={item.link}
                    />
                    <img
                      className="card-revised-badge"
                      src={item.badge}
                      alt="Revised"
                    />
                  </div>
                ) : (
                  <Button
                    onClick={handleShowPopUpForm}
                    className="card-btn"
                    text={item.text}
                    color={item.color}
                    link={item.link}
                  />
                );
              case "button-group":
                return (
                  <div className="card-btn-row">
                    {item.buttons.map((btn) => (
                      <Button
                        key={btn.text}
                        onClick={handleShowPopUpForm}
                        className="card-btn"
                        text={btn.text}
                        color={btn.color}
                        link={btn.link}
                      />
                    ))}
                  </div>
                );
              case "bottom-paragraph":
                return item.text.includes("<a") ? (
                  <p
                    style={{ color: item.color, margin: 0 }}
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  />
                ) : (
                  <p
                    className="bottom-paragraph"
                    style={{ color: item.color, margin: 0 }}
                  >
                    {item.text}
                  </p>
                );
              case "icons":
                return (
                  <div className="card-btn-group">
                    {" "}
                    {item.icons.map((icon) => (
                      <div className="fa-icon">
                        <a
                          href="https://www.7-zip.org/download.html"
                          title={icon.title}
                          aria-label={icon.aria}
                        >
                          <i
                            className={`fa-brands ${icon.icon} fa-xl`}
                            alt="Windows"
                          ></i>
                        </a>
                      </div>
                    ))}{" "}
                  </div>
                );
              default:
                return <p></p>;
            }
          })}
      </div>
      <PopUpModal
        activeForm={id}
        formActiveState={popUpFormVisible}
        setFormActiveState={setPopUpFormVisible}
      >
        {popUpComponent}
      </PopUpModal>
    </div>
  );
};

export default HomeScorecardCard;
